'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItem = undefined;

var _MenuItem$childContex;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleIcons = require('reactackle-icons');

var _reactackleCore = require('reactackle-core');

var _broadcastsConstants = require('../broadcastsConstants');

var _MenuItemStyled = require('./styles/MenuItemStyled');

var _AnchorStyled = require('./styles/AnchorStyled');

var _ContentStyled = require('./styles/ContentStyled');

var _TextPrimaryStyled = require('./styles/TextPrimaryStyled');

var _TextSecondaryStyled = require('./styles/TextSecondaryStyled');

var _IconLeftStyled = require('./styles/IconLeftStyled');

var _IconRightStyled = require('./styles/IconRightStyled');

var _ImageStyled = require('./styles/ImageStyled');

var _ExpandButtonStyled = require('./styles/ExpandButtonStyled');

var _ExpandIconStyled = require('./styles/ExpandIconStyled');

var _AddonRightStyled = require('./styles/AddonRightStyled');

var _TextRightStyled = require('./styles/TextRightStyled');

var _MenuLink = require('./MenuLink');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  /**
   * Item id
   */
  id: _propTypes2.default.string,

  /**
   * Defines left icon element
   */
  iconLeft: _propTypes2.default.element,

  /**
   * Defines right icon element
   */
  iconRight: _propTypes2.default.element,

  /**
   * Defines right text element
   */
  textRight: _propTypes2.default.string,

  /**
   * Defines left image element
   */
  image: _propTypes2.default.string,

  /**
   * Defines item's link
   */
  linkHref: _propTypes2.default.string,

  /**
   * Primary item text
   */
  text: _propTypes2.default.string,

  /**
   * Secondary item text
   */
  textSecondary: _propTypes2.default.string,

  /**
   * Allow item to behave like a link
   */
  renderLink: _propTypes2.default.bool,

  /**
   * Define link component
   */
  linkComponent: _propTypes2.default.func,

  /**
   * Primary right add-on element
   */
  addonRight: _propTypes2.default.element,

  /**
   * Define item colorScheme
   */
  colorScheme: _propTypes2.default.oneOf(['light', 'dark']),

  /**
   * Display item as active
   */
  active: _propTypes2.default.bool,

  /**
   * Simulate image offset for item without image
   */
  addImageOffset: _propTypes2.default.bool,

  /**
   * Simulate image offset for item without left icon
   */
  addIconOffset: _propTypes2.default.bool,

  /**
   * Simulate item offset for nested trees
   */
  nestingLevel: _propTypes2.default.number,

  /**
   * Set item inClick function
   */
  onClick: _propTypes2.default.func,

  /**
   * Define expand icon element
   */
  iconExpand: _propTypes2.default.element
};
var defaultProps = {
  id: '',
  iconLeft: null,
  iconRight: null,
  textRight: '',
  image: '',
  linkHref: '#',
  text: '',
  textSecondary: '',
  renderLink: false,
  linkComponent: _MenuLink.MenuLink,
  addonRight: null,
  colorScheme: 'dark',
  active: false,
  addImageOffset: false,
  addIconOffset: false,
  nestingLevel: 0,
  onClick: _reactackleCore.noop,
  iconExpand: _react2.default.createElement(_reactackleIcons.IconArrowChevronRight, {
    color: 'currentColor',
    size: 'custom'
  })
};

var MenuItem = exports.MenuItem = function (_React$Component) {
  _inherits(MenuItem, _React$Component);

  function MenuItem(props) {
    _classCallCheck(this, MenuItem);

    var _this = _possibleConstructorReturn(this, (MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call(this, props));

    _this._broadcast = (0, _reactackleCore.createBroadcast)({
      nestingLevel: _this.props.nestingLevel,
      colorScheme: _this.props.colorScheme
    });
    _this.state = {
      submenuOpen: false
    };
    _this._toggleMenu = _this._toggleMenu.bind(_this);
    _this._handleClick = _this._handleClick.bind(_this);
    _this._createElementRef = _this._createElementRef.bind(_this);
    _this._handleExpandIconClick = _this._handleExpandIconClick.bind(_this);
    return _this;
  }

  _createClass(MenuItem, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _extends2;

      return _extends({}, this.context, (_extends2 = {}, _defineProperty(_extends2, _broadcastsConstants.MENU_BROADCAST, this._broadcast.subscribe), _defineProperty(_extends2, _broadcastsConstants.MENU_GROUP_BROADCAST, this._broadcast.subscribe), _extends2));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.colorScheme !== nextProps.colorScheme) {
        this._broadcast.publish({
          colorScheme: nextProps.colorScheme
        });
      }
    }
  }, {
    key: '_toggleMenu',
    value: function _toggleMenu(open) {
      if (this.props.children) {
        this.setState({
          submenuOpen: typeof open === 'boolean' ? open : !this.state.submenuOpen
        });
      }
    }
  }, {
    key: '_handleExpandIconClick',
    value: function _handleExpandIconClick(event) {
      event.preventDefault();

      this._toggleMenu();
    }
  }, {
    key: '_handleClick',
    value: function _handleClick() {
      if (!this.props.children) this.closeRootMenu();else this._toggleMenu();
      this.props.onClick();
    }
  }, {
    key: 'closeRootMenu',
    value: function closeRootMenu() {
      document.dispatchEvent(new MouseEvent('click'));
    }
  }, {
    key: '_createElementRef',
    value: function _createElementRef(ref) {
      this.element = ref;
    }
  }, {
    key: 'render',
    value: function render() {
      var href = this.props.linkHref;

      var iconLeft = this.props.iconLeft && _react2.default.createElement(_IconLeftStyled.IconLeftStyled, {
        colorScheme: this.props.colorScheme,
        active: this.props.active
      }, this.props.iconLeft);

      var iconRight = this.props.iconRight && _react2.default.createElement(_IconRightStyled.IconRightStyled, {
        colorScheme: this.props.colorScheme,
        active: this.props.active
      }, this.props.iconRight);

      var textRight = this.props.textRight && _react2.default.createElement(_TextRightStyled.TextRightStyled, {
        colorScheme: this.props.colorScheme,
        active: this.props.active
      }, this.props.textRight);

      var image = this.props.image && _react2.default.createElement(_ImageStyled.ImageStyled, {
        imageOnly: !this.props.text && !this.props.iconLeft && !this.props.iconRight,
        style: {
          backgroundImage: 'url(' + this.props.image + ')'
        }
      });

      var textSecondary = this.props.textSecondary && _react2.default.createElement(_TextSecondaryStyled.TextSecondaryStyled, {
        colorScheme: this.props.colorScheme,
        active: this.props.active
      }, this.props.textSecondary);

      var text = this.props.text && _react2.default.createElement(_ContentStyled.ContentStyled, {
        nestingLevel: this.props.nestingLevel,
        addImageOffset: this.props.addImageOffset,
        addIconOffset: this.props.addIconOffset
      }, _react2.default.createElement(_TextPrimaryStyled.TextPrimaryStyled, null, this.props.text), textSecondary);

      var expandButton = this.props.children && _react2.default.createElement(_ExpandButtonStyled.ExpandButtonStyled, {
        colorScheme: this.props.colorScheme,
        active: this.props.active,
        onClick: this._handleExpandIconClick
      }, _react2.default.createElement(_ExpandIconStyled.ExpandIconStyled, {
        opened: this.state.submenuOpen
      }, this.props.iconExpand));

      var ItemWrapper = this.props.renderLink ? _AnchorStyled.AnchorStyled.withComponent(this.props.linkComponent) : _AnchorStyled.AnchorStyled.withComponent('div');
      var itemWrapperProps = {
        colorScheme: this.props.colorScheme,
        active: this.props.active,
        onClick: this._handleClick
      };
      if (this.props.renderLink) itemWrapperProps.href = href;

      var addonRight = this.props.addonRight && _react2.default.createElement(_AddonRightStyled.AddonRightStyled, null, this.props.addonRight);

      var children = this.props.children;
      return _react2.default.createElement(_MenuItemStyled.MenuItemStyled, {
        innerRef: this._createElementRef,
        tabIndex: -1,
        id: this.props.id
      }, _react2.default.createElement(ItemWrapper, itemWrapperProps, iconLeft, image, text, textRight, iconRight, addonRight, expandButton), this.state.submenuOpen && children);
    }
  }]);

  return MenuItem;
}(_react2.default.Component);

MenuItem.propTypes = propTypes;
MenuItem.defaultProps = defaultProps;
MenuItem.displayName = 'MenuItem';
MenuItem.childContextTypes = (_MenuItem$childContex = {}, _defineProperty(_MenuItem$childContex, _broadcastsConstants.MENU_BROADCAST, _propTypes2.default.func.isRequired), _defineProperty(_MenuItem$childContex, _broadcastsConstants.MENU_GROUP_BROADCAST, _propTypes2.default.func.isRequired), _MenuItem$childContex);
var MenuItemWithMenuProps = (0, _reactackleCore.withExternalProps)(_broadcastsConstants.MENU_BROADCAST)(function (_ref) {
  var externalProps = _ref.externalProps,
      props = _objectWithoutProperties(_ref, ['externalProps']);

  return _react2.default.createElement(MenuItem, _extends({}, externalProps, props));
});
exports.default = (0, _reactackleCore.withExternalProps)(_broadcastsConstants.MENU_GROUP_BROADCAST)(function (_ref2) {
  var externalProps = _ref2.externalProps,
      props = _objectWithoutProperties(_ref2, ['externalProps']);

  return _react2.default.createElement(MenuItemWithMenuProps, _extends({}, externalProps, props));
});